import { render, staticRenderFns } from "./MaterialSnRuleDetailsEdit.vue?vue&type=template&id=11f8e7de&"
import script from "./MaterialSnRuleDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialSnRuleDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports